import Script from "next/script";
import { useEffect, useState } from "react";
import styles from "./KlarnaPaymentMessage.module.scss";
import { RuntimeConfig } from "@/types/types.ts";
import { dispatchMonetateQEvent } from "@/utils/monetate/monetateQ.ts";

type Props = {
  currentPrice?: string;
  isSelected: boolean;
  runtimeConfig: RuntimeConfig;
};

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    export interface IntrinsicElements {
      "klarna-placement": {
        id: string;
        "data-key": string;
        "data-locale": string;
        "data-purchase-amount"?: string;
      };
    }
  }
}

// Klarna PDP Events
export const EVENT_DISPLAY_INSTALMENT =
  "WPDP | Credit Offer Displayed | Klarna Instalment";
export const EVENT_DISPLAY_GENERIC =
  "WPDP | Credit Offer Displayed | Klarna Generic";

export const KlarnaPaymentMessageUI = ({
  currentPrice,
  isSelected,
  runtimeConfig,
}: Props) => {
  const [amount, setAmount] = useState<string | undefined>("");

  useEffect(() => {
    if (isSelected) {
      const flatPrice = Math.round(Number(currentPrice) * 100);
      setAmount(flatPrice.toString());
      dispatchMonetateQEvent(EVENT_DISPLAY_INSTALMENT);
    } else {
      dispatchMonetateQEvent(EVENT_DISPLAY_GENERIC);
      setAmount("10");
    }
  }, [isSelected, currentPrice]);

  return (
    <>
      <Script
        async
        data-environment={runtimeConfig?.klarnaEnvironment}
        src={runtimeConfig?.klarnaScriptURL}
        data-client-id={runtimeConfig?.klarnaClientId}
      />
      <style>
        {`
          #klarnaPlacementMessage::part(osm-container),
          #klarnaPlacementMessage::part(osm-cta){
            font-family: GillSansforJL, Gill Sans, Gill Sans MT, GillSansMTStd-Medium, Avenir, Corbel, Arial, Helvetica, sans-serif;
            color: #141414;
          }

          #klarnaPlacementMessage::part(osm-legal) {
            color: #6F6F6F;
            text-align: left;
          }
        `}
      </style>
      <div
        className={styles.klarnaPaymentMessage__block}
        data-component="KlarnaPaymentMessage"
        data-testid="klarna-payment-message-container"
      >
        <klarna-placement
          id="klarnaPlacementMessage"
          data-key={
            isSelected
              ? "credit-promotion-auto-size"
              : "top-strip-promotion-auto-size"
          }
          data-locale="en-GB"
          data-purchase-amount={amount}
        />
      </div>
    </>
  );
};
